import { useNotepadStore } from "../store/useNotepadStore";

interface NotepadCloseConfirmModalProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export function NotepadCloseConfirmModal({
  onConfirm,
  onCancel,
}: NotepadCloseConfirmModalProps) {
  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      onClick={(e) => e.target === e.currentTarget && onCancel()}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-md" aria-hidden="true" />

      {/* Modal */}
      <div
        role="dialog"
        aria-modal="true"
        className="relative bg-white rounded-[30px] shadow-xl w-[90%] max-w-[500px] p-6 mx-4 z-10"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Warning icon */}
        <div className="flex justify-center mb-5 mt-1">
          <img src="/assets/warning.svg" alt="Warning" className="w-[121px] h-[121px]" />
        </div>

        {/* Title */}
        <h2 className="text-center text-[#252525] font-mulish font-bold text-[25px] leading-[100%] mb-4" style={{ fontFamily: "'Mulish', sans-serif" }}>
          Close Notepad?
        </h2>

        {/* Message */}
        <p className="text-center text-[#878787] font-mulish text-[20px] font-[600] leading-[120%] mb-6 mx-1" style={{ fontFamily: "'Mulish', sans-serif" }}>
          The tutor is still explaining. If you close the notepad now, all your work would be lost.
        </p>

        {/* Buttons: Cancel on left, Close on right */}
        <div className="flex gap-3 justify-center">
          <button
            onClick={onCancel}
            className="py-4 px-6 bg-white text-lightgreen text-[20px] font-[600] font-mulish hover:bg-[#E6FFF6] focus:bg-[#C6EBDD] rounded-xl transition-colors duration-200"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="py-4 px-6 bg-[#1C9C6D] hover:bg-[#178a5f] text-white text-[20px] font-[600] font-mulish rounded-[15px] transition-colors duration-200"
          >
            Close Notepad
          </button>
        </div>
      </div>
    </div>
  );
}
